export const TERMS_CALL = "TERMS_CALL";

export function callTerms() {
  return { type: TERMS_CALL };
}
